import { render, staticRenderFns } from "./warehouseManagement.vue?vue&type=template&id=8a8c086e&scoped=true&"
import script from "./warehouseManagement.vue?vue&type=script&lang=js&"
export * from "./warehouseManagement.vue?vue&type=script&lang=js&"
import style0 from "./warehouseManagement.vue?vue&type=style&index=0&id=8a8c086e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a8c086e",
  null
  
)

export default component.exports